export default "__VITE_ASSET__3fc7cac0__"